module.exports = __webpack_public_path__ + "img/revit.58f556dd.svg";